module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/My-Dinner-With-Herve.a850cca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/My-Dinner-With-Herve.jpg
// module id = 3bTO
// module chunks = 0